import React from 'react';
import { Grid } from '@material-ui/core';
import { RMSTextField, RMSSelect, RMSCheckbox } from '../../../shared/components/form-controls';
import SectionCard from '../../../shared/components/cards/SectionCard';
import { ZONE_TEXT_FIELDS } from '../../constants/zoneFormConstants';

const ZoneDetailsForm = ({ agencies }) => (
  <SectionCard label="Zone Details">
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <RMSSelect name="AgencyID" label="Agency" options={agencies} />
      </Grid>
      {ZONE_TEXT_FIELDS.map((field) => (
        <Grid item xs={12} sm={6} key={field.name}>
          <RMSTextField {...field} disabled={field.name === 'ZoneCode'} />
        </Grid>
      ))}
      <Grid item xs={6}>
        <RMSCheckbox name="IsDefault" label="Default" />
      </Grid>
      <Grid item xs={6}>
        <RMSCheckbox name="IsActive" label="Active" />
      </Grid>
    </Grid>
  </SectionCard>
);
export default ZoneDetailsForm;
